/* src/app/shared/components/imprint/imprint.component.scss */
.main-div {
  padding-left: 1em;
}
/*# sourceMappingURL=imprint.component.css.map */
